import React from 'react';

const motivations = [
  {
    index: '01',
    title: 'Useful over impressive',
    copy: 'I care less about technology for its own sake and more about whether it removes friction, creates clarity, or helps someone move forward.'
  },
  {
    index: '02',
    title: 'Curiosity with direction',
    copy: 'I’m happiest learning something unfamiliar, connecting ideas across disciplines, and turning that curiosity into a working experiment.'
  },
  {
    index: '03',
    title: 'Systems that endure',
    copy: 'Good products need more than a compelling interface. I enjoy shaping the invisible foundations that make them reliable, scalable and trusted.'
  }
];

const About: React.FC = () => (
  <section id="about" className="about-section py-24">
    <div className="section-transition" aria-hidden="true"><span>What sits beneath the work</span></div>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="section-heading mb-14">
        <div>
          <span className="section-eyebrow">What drives me / 01</span>
          <h2 className="text-4xl md:text-6xl font-bold text-white mt-3">I build because ideas deserve a chance to become real.</h2>
        </div>
        <p className="section-heading-copy">
          Technology is my medium, not my identity. What keeps me moving is the possibility of understanding a difficult problem, finding the human need inside it, and creating something that makes a meaningful difference.
        </p>
      </div>

      <div className="motivation-layout">
        <div className="motivation-manifesto">
          <span className="manifesto-mark">“</span>
          <p>I’m drawn to the space between <strong>what exists</strong> and <strong>what could work better</strong>.</p>
          <p>Sometimes the answer is an intelligent workflow. Sometimes it is a resilient platform. Sometimes it is simply a clearer way for people to act.</p>
        </div>
        <div className="motivation-principles">
          {motivations.map(item => (
            <article key={item.index} className="motivation-principle">
              <span>{item.index}</span>
              <div><h3>{item.title}</h3><p>{item.copy}</p></div>
            </article>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default About;
